exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#app .remind__header{font-size:20px !important}", "", {"version":3,"sources":["/home/webuser/akula/releases/150/spa/src/pages/auth/remindPassword/RemindPassword.scss"],"names":[],"mappings":"AAKI,qBACE,yBAAA,CAAA","file":"RemindPassword.scss?vue&type=style&index=0&prod&lang=scss&external","sourcesContent":[".remind {\n}\n\n#app {\n  .remind {\n    &__header {\n      font-size: 20px!important;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
